// biome-ignore lint/style/noRestrictedImports: encapsulation
import { omit as omit_ } from "remeda";

import { unpurry } from "./_unpurry";

export const omit = unpurry(omit_, 2);
